export const ASSISTENCIA_IMAGE_ACCEPT = 'image/png,image/jpeg,image/jpg,image/webp';
export const ASSISTENCIA_IMAGE_MAX_BYTES = 2 * 1024 * 1024;

export const EMPTY_ASSISTENCIA_FORM = {
  nome: '',
  cidade: '',
  estado: '',
  email: '',
  emailhp: '',
  valor: '',
  valorhp: '',
  valorloc: '',
  currency: 'BRL',
  format: 'pt-BR',
  desconto: '',
  status: 'ativo',
  logo: '',
  assinatura: '',
};

export const assistenciaToForm = (assistencia = {}) => ({
  nome: assistencia.nome || '',
  cidade: assistencia.cidade || '',
  estado: assistencia.estado || '',
  email: assistencia.email || '',
  emailhp: assistencia.emailhp || '',
  valor: assistencia.valor !== undefined && assistencia.valor !== null ? String(assistencia.valor) : '',
  valorhp: assistencia.valorhp !== undefined && assistencia.valorhp !== null ? String(assistencia.valorhp) : '',
  valorloc: assistencia.valorloc !== undefined && assistencia.valorloc !== null ? String(assistencia.valorloc) : '',
  currency: assistencia.currency || 'BRL',
  format: assistencia.format || (assistencia.currency === 'USD' ? 'en-US' : 'pt-BR'),
  desconto: assistencia.desconto !== null && assistencia.desconto !== undefined && assistencia.desconto !== ''
    ? String(assistencia.desconto)
    : '',
  status: assistencia.status === 'inativo' ? 'inativo' : 'ativo',
  logo: assistencia.logo || '',
  assinatura: assistencia.assinatura || '',
});

export const validateAssistenciaImageFile = (file) => {
  if (!file) return null;

  const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
  if (!allowedTypes.includes(file.type)) {
    return 'Formato inválido. Use PNG, JPG ou WEBP.';
  }

  if (file.size > ASSISTENCIA_IMAGE_MAX_BYTES) {
    return 'A imagem deve ter no máximo 2MB.';
  }

  return null;
};

const appendIfDefined = (formData, key, value) => {
  if (value === undefined || value === null) return;
  formData.append(key, value);
};

export const buildAssistenciaFormData = (form, { logoFile, assinaturaFile } = {}) => {
  const formData = new FormData();

  formData.append('nome', form.nome.trim());
  appendIfDefined(formData, 'cidade', form.cidade.trim());
  appendIfDefined(formData, 'estado', form.estado.trim().toUpperCase());
  formData.append('email', form.email.trim());
  appendIfDefined(formData, 'emailhp', form.emailhp.trim());
  formData.append('valor', String(parseFloat(form.valor) || 0));
  formData.append('valorhp', String(parseFloat(form.valorhp) || 0));
  formData.append('valorloc', String(parseFloat(form.valorloc) || 0));
  formData.append('currency', form.currency || 'BRL');
  formData.append('format', form.format || 'pt-BR');
  if (form.desconto !== '' && form.desconto != null) {
    formData.append('desconto', String(parseFloat(form.desconto)));
  }
  formData.append('status', form.status || 'ativo');

  if (form.password?.trim()) {
    formData.append('password', form.password.trim());
  }

  if (logoFile instanceof File) {
    formData.append('logo', logoFile);
  }

  if (assinaturaFile instanceof File) {
    formData.append('assinatura', assinaturaFile);
  }

  return formData;
};

/** @deprecated Use buildAssistenciaFormData para create/update com imagens */
export const buildAssistenciaPayload = (form) => ({
  nome: form.nome.trim(),
  cidade: form.cidade.trim(),
  estado: form.estado.trim().toUpperCase(),
  email: form.email.trim(),
  emailhp: form.emailhp.trim(),
  valor: parseFloat(form.valor) || 0,
  valorhp: parseFloat(form.valorhp) || 0,
  valorloc: parseFloat(form.valorloc) || 0,
  currency: form.currency,
  format: form.format,
  desconto: form.desconto ? parseFloat(form.desconto) : null,
  status: form.status,
});
